export default [
	{
		path: '/',
		name: 'MainLayout',
		component: () => import('@/pages/_MainLayout/MainLayout.vue'),
		redirect: '/edi-invoices',
		children: [
			{
				path: '/user-profile',
				name: 'User Profile',
				component: () => import('@/pages/Profile/Profile.vue'),
				meta: {
					title: 'User Profile',
					icon: 'mdi-account-box'
				}
			},
			{
				path: '/invoice-records',
				name: 'Invoice Records',
				component: () => import('@/pages/InvoiceRecords/InvoiceRecords.vue'),
				meta: {
					title: 'Invoice Records'
				}
			},
			{
				path: '/invoice-items',
				name: 'Invoice Items',
				component: () => import('@/pages/InvoiceItems/InvoiceItems.vue'),
				meta: {
					title: 'Invoice Items'
				}
			},
			{
				path: '/upload/',
				name: 'Upload Invoice/Template',
				component: () => import('@/pages/Upload/Upload.vue'),
				meta: {
					title: 'Upload'
				}
			},
			{
				path: '/upload-list',
				name: 'Upload List',
				component: () => import('@/pages/UploadList/UploadList.vue'),
				meta: {
					title: 'Upload List'
				}
			},
			{
				path: '/quickbooks',
				name: 'Quickbooks',
				component: () => import('@/pages/Quickbook/Quickbooks.vue'),
				redirect: '/quickbooks/logs',
				meta: {
					title: 'Quickbooks'
				},
				children: [
					{
						path: '/quickbooks/logs',
						name: 'Quickbook Logs',
						component: () => import('@/pages/QuickbookLogs/QuickbookLogs.vue'),
						meta: {
							title: 'Quickbook Logs'
						}
					},
					{
						path: '/quickbooks/import',
						name: 'Quickbook Import',
						component: () => import('@/pages/QuickbookImport/QuickbookImport.vue'),
						meta: {
							title: 'Quickbook Import'
						}
					}
				]
			},
			{
				path: '/extensiv',
				name: 'Extensiv',
				component: () => import('@/pages/Extensiv/Extensiv.vue'),
				redirect: '/extensiv/logs',
				meta: {
					title: 'Extensiv'
				},
				children: [
					{
						path: '/extensiv/logs',
						name: 'Extensiv Logs',
						component: () => import('@/pages/ExtensivLogs/ExtensivLogs.vue'),
						meta: {
							title: 'Extensiv Logs'
						}
					},
					{
						path: '/extensiv/import',
						name: 'Extensiv Import',
						component: () => import('@/pages/ExtensivImport/ExtensivImport.vue'),
						meta: {
							title: 'Extensiv Import'
						}
					}
				]
			},
			{
				path: '/upload-result',
				name: 'Upload Result',
				component: () => import('@/pages/UploadResult/UploadResult.vue'),
				meta: {
					title: 'Upload Result'
				}
			},
			{
				path: '/parsers',
				name: 'PDF Parsers',
				component: () => import('@/pages/Parsers/Parsers.vue'),
				meta: {
					title: 'PDF Parsers'
				}
			},
			{
				path: '/parsers/:id',
				name: 'Parsers Data',
				component: () => import('@/pages/ParsersData/ParsersData.vue'),
				meta: {
					title: 'Parsers Data'
				}
			},
			{
				path: '/excel-parsers',
				name: 'Excel Parsers',
				component: () => import('@/pages/ExcelParser/ExcelParser.vue'),
				meta: {
					title: 'Excel Parsers'
				}
			},
			{
				path: '/pdf-merge-split',
				name: 'PDF Merge & Split',
				component: () => import('@/pages/PDFMergeAndSplit/PDFMergeAndSplit.vue'),
				meta: {
					title: 'PDF Merge & Split'
				}
			},
			{
				path: '/edi-invoices',
				name: 'EDI Invoices',
				component: () => import('@/pages/EDI/EDI.vue'),
				meta: {
					title: 'EDI Invoices'
				}
			},
			{
				path: '/edi-preview',
				name: 'EDI Preview',
				component: () => import('@/pages/EDI/EDIPreview.vue'),
				meta: {
					title: 'EDI Preview'
				}
			},
			{
				path: '/guide',
				name: 'Guide',
				component: () => import('@/pages/Guide/Guide.vue'),
				meta: {
					title: 'Guide'
				}
			}
		],
		meta: {
			requiresAuth: true,
			title: 'Dashboard',
		}
	},
	{
		path: '/signin',
		name: 'Signin',
		component: () => import('@/pages/Signin/Signin.vue'),
		meta: {
			title: 'Signin'
		}
	},
	{
		path: '/forgot-password',
		name: 'Forgot Password',
		component: () => import('@/pages/ForgotPassword/ForgotPassword.vue'),
		meta: {
			title: 'Forgot Password'
		}
	},
	{
		path: '/reset/:token',
		name: 'Reset Password',
		component: () => import('@/pages/ResetPassword/ResetPassword.vue'),
		meta: {
			title: 'Reset Password'
		}
	},
	{
		path: '/v1/signup',
		name: 'Signup',
		component: () => import('@/pages/Signup/Signup.vue'),
		meta: {
			title: 'Signup'
		}
	},
	{
		path: '*',
		component: () => import('@/pages/PageNotFound/PageNotFound.vue'),
		meta: {
			title: 'Page Not Found'
		}
	}
];
